import { render, staticRenderFns } from "./SearchListItem.vue?vue&type=template&id=5923b23f"
import script from "./SearchListItem.vue?vue&type=script&lang=js"
export * from "./SearchListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports